module.exports = __webpack_public_path__ + "static/TiltBanana-bf71cbff7d2e3a73411cedb3da694f61.jpg";